import { useProjectName } from './useProjectName';

export const useHeaderBg = () => {
  const project = useProjectName();

  let headerBg = `/projects/${project}/background_header.png`;
  
  return headerBg
}